import ElasticProcessor from '@lib/processors/elastic-processor'
import StatusMap from '~/utils/status-map'

const TABLE_FILTERS = [
  {
    attribute: 'createdAt',
    label: 'Date Created',
    type: 'date',
    icon: 'el-icon-date',
  },
  {
    attribute: 'objectsAdded',
    label: 'Products Added',
    type: 'numeric',
    icon: 'el-icon-box',
  },
  {
    attribute: 'objectsUpdated',
    label: 'Products Updated',
    type: 'numeric',
    icon: 'el-icon-box',
  },
  {
    attribute: 'objectsDeleted',
    label: 'Products Deleted',
    type: 'numeric',
    icon: 'el-icon-box',
  },
  // NOTE We can't sort by status because it's calculated
  // {
  //   attribute: 'status',
  //   label: 'Status',
  //   icon: 'el-icon-circle-check',
  // },
]

const TABLE_COLUMNS = [
  {
    name: 'createdAt',
    label: 'Date Created',
    format: 'dateTime',
    icon: 'el-icon-date',
    width: 180,
  },
  {
    name: 'objectsAdded',
    label: 'Products Added',
    icon: 'el-icon-document',
    width: 120,
  },
  {
    name: 'objectsUpdated',
    label: 'Products Updated',
    icon: 'el-icon-document',
    width: 140,
  },
  {
    name: 'objectsDeleted',
    label: 'Products Deleted',
    icon: 'el-icon-document',
    width: 140,
  },
  {
    name: 'status',
    label: 'Status',
    icon: 'el-icon-circle-check',
    width: 200,
    format: 'capital',
    component: {
      props: {
        value(_, row) {
          const statusObj = StatusMap(row.internalStatus, row.externalStatus)
          return statusObj ? statusObj.label : ''
        },
        styleObj(_, row) {
          const statusObj = StatusMap(row.internalStatus, row.externalStatus)
          return statusObj ? { color: statusObj.color } : {}
        },
        badge(_, row) {
          const statusObj = StatusMap(row.internalStatus, row.externalStatus)
          const name = statusObj ? `el-icon-${statusObj.icon}` : ''
          return {
            name,
            pos: 'left',
          }
        },
      },
    },
  },
]

export default component => ({
  processor: new ElasticProcessor({
    component,
    index: 'publishing-statuses',
    staticDataQuery: {
      filters: [
        {
          attribute: 'providerId',
          comparison: 'eq',
          value: component.provider.id,
        },
      ],
    },
    initialDataQuery: {
      defaultSort: {
        createdAt: 'desc',
      },
    },
  }),
  filters: TABLE_FILTERS,
  columns: TABLE_COLUMNS,
  tableName: 'provider-publishing',
})
